import React, {useEffect} from "react";
import {
    useLazyGetAdministrativeAndFunctionalZoneQuery,
    useLazyGetProductionStageQuery, useLazySearchAdministrativeAndFunctionalZoneGuidePageQuery,
    useLazySearchProductionStagesGuidePageQuery,
    useSearchProductionOrderJournalPageQuery
} from "../../store/backend-api/backend.api";
import {useFiltersActions} from "../../hooks/useFiltersActions";
import {useAppSelector} from "../../hooks/useAppSelector";
import {TableFilterKey} from "../../model/filters/TableFiltersDefinitions";
import {GuideTopBox} from "../../components/ui/table-components/GuideTopBox";
import {useFilterNodesActions} from "../../hooks/useMenuFiltersActions";
import {productionOrderStatusToString} from "../../data/ProductionOrderData";
import {useDataActions} from "../../hooks/useDataActions";
import {
    DEFAULT_ADMINISTRATIVE_AND_FUNCTIONAL_ZONE_GUIDE_FILTER,
    DEFAULT_PRODUCTION_ORDER_ARCHIVE_FILTER
} from "../../model/filters/DefaultFilters";
import {MultiSelect} from "../../components/ui/form-components/standalone/MultiSelect";
import {OptionType} from "../../model/option-type/OptionType";
import {ProductionOrderStatus} from "../../model/production-order/ProductionOrder";
import {ProductionOrderArchiveTable} from "../../components/production-order-archive/ProductionOrderArchiveTable";
import {tablePageStyle} from "../../utils/TailwindStyles";
import {NewPaginateAsyncSelect} from "../../components/ui/form-components/standalone/NewPaginateAsyncSelect";
import {UpdateFilter} from "../../store/slices/filters.slice";
import {TablePage} from "../../model/utils/TablePage";
import {
    AdministrativeAndFunctionalZoneGuideRow
} from "../../model/administrative-and-functional-zone/AdministrativeAndFunctionalZoneGuideRow";
import {
    AdministrativeAndFunctionalZonePurpose
} from "../../model/administrative-and-functional-zone/AdministrativeAndFunctionalZone";
import {PaginateAsyncMultiSelect} from "../../components/ui/form-components/standalone/PaginateAsyncMultiSelect";
import {ProductionStage} from "../../model/production-stage/ProductionStage";
import {SeparatedDatePicker} from "../../components/ui/form-components/standalone/SeparatedDatePicker";
import {RadioGroup} from "../../components/ui/form-components/standalone/RadioGroup";
import {
    getAdministrativeAndFunctionalZoneForFilters,
    getProductionStagesForFilters
} from "../production-order/ProductionOrderDocumentJournal";

export function ProductionOrderArchiveJournal() {
    const [doSearchProductionStagesGuidePage] = useLazySearchProductionStagesGuidePageQuery();
    const [doGetProductionStage] = useLazyGetProductionStageQuery();
    const [doGetAdministrativeAndFunctionalZone] = useLazyGetAdministrativeAndFunctionalZoneQuery();
    const [doSearchAdministrativeAndFunctionalZoneGuidePage] = useLazySearchAdministrativeAndFunctionalZoneGuidePageQuery();

    const {updateFilterAndClearData} = useFiltersActions()
    const {addFiltersToMenu} = useFilterNodesActions()
    const {addData} = useDataActions()

    const state = useAppSelector(state => state.sessionStorage.filters)
    const filter = state[TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER].filter;

    const data = useAppSelector(state => state.data.data[TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER
        ])

    const {data: tablePage} = useSearchProductionOrderJournalPageQuery(filter)

    const selectOptions = Array.from(productionOrderStatusToString.keys()).map(key => ({
        label: productionOrderStatusToString.get(key)!,
        value: key
    }))

    useEffect(() => {
        getProductionStagesForFilters(filter.productionStageIds, doGetProductionStage)
            .then(defaultOptionsForProductionStages =>
                getAdministrativeAndFunctionalZoneForFilters(filter.productionLineId, defaultOptionsForProductionStages, doGetAdministrativeAndFunctionalZone)
                    .then(object =>
                        addFiltersToMenu({
                            key: TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER,
                            value: [
                                {
                                    filterName: "Производственная линия",
                                    filter: <NewPaginateAsyncSelect onChange={(option: OptionType<number> | null) => {
                                        const newFilter: UpdateFilter = {
                                            key: TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER,
                                            value: {...filter, productionLineId: option ? option.value : null}
                                        }
                                        updateFilterAndClearData(newFilter)
                                    }} defaultOption={object.defaultOptionForAdministrativeAndFunctionalZone}
                                                                    width={"270px"}
                                                                    request={doSearchAdministrativeAndFunctionalZoneGuidePage}
                                                                    mapFunc={(data: TablePage<AdministrativeAndFunctionalZoneGuideRow>) =>
                                                                        data.rows.map(row => ({
                                                                            label: row.name,
                                                                            value: row.id
                                                                        }))
                                                                    }
                                                                    filter={{
                                                                        ...DEFAULT_ADMINISTRATIVE_AND_FUNCTIONAL_ZONE_GUIDE_FILTER,
                                                                        purpose: AdministrativeAndFunctionalZonePurpose.PRODUCTION_LINE
                                                                    }}/>
                                },
                                {
                                    filterName: "Статус заказа",
                                    filter: <MultiSelect options={selectOptions}
                                                         onChange={(options: readonly OptionType<ProductionOrderStatus>[] | null) => {
                                                             updateFilterAndClearData({
                                                                 key: TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER,
                                                                 value: {
                                                                     ...filter,
                                                                     status: options ? options.map(option => option.value) : []
                                                                 }
                                                             })
                                                         }}
                                                         width={"270px"}
                                                         defaultOptions={filter.status.map(status => ({
                                                             label: productionOrderStatusToString.get(status)!,
                                                             value: status
                                                         }))}
                                    />
                                }, {
                                    filterName: "Этапы производства",
                                    filter: <PaginateAsyncMultiSelect
                                        onChange={(options: OptionType<number>[] | null) => {
                                            const newFilter: UpdateFilter = {
                                                key: TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER,
                                                value: {
                                                    ...filter,
                                                    productionStageIds: options ? options.map(option => option.value) : []
                                                }
                                            }
                                            updateFilterAndClearData(newFilter)
                                        }} defaultOptions={object.defaultOptionsForProductionStages} width={"270px"}
                                        request={doSearchProductionStagesGuidePage}
                                        mapFunc={(data: TablePage<ProductionStage>) =>
                                            data.rows.map(row => ({label: row.name, value: row.id}))
                                        }/>
                                }, {
                                    filterName: "Требуется завершить",
                                    filter: <SeparatedDatePicker
                                        onChange={(startDate: Date | null, endDate: Date | null) => {
                                            updateFilterAndClearData({
                                                key: TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER,
                                                value: {
                                                    ...filter,
                                                    planningCompletionDateFrom: startDate ? startDate.toISOString().slice(0, 10) : null,
                                                    planningCompletionDateTo: endDate ? endDate.toISOString().slice(0, 10) : null
                                                }
                                            })
                                        }}
                                        startDate={filter.planningCompletionDateFrom ? new Date(filter.planningCompletionDateFrom) : undefined}
                                        endDate={filter.planningCompletionDateTo ? new Date(filter.planningCompletionDateTo) : undefined}
                                    />
                                }, {
                                    filterName: "Завершён",
                                    filter: <SeparatedDatePicker
                                        onChange={(startDate: Date | null, endDate: Date | null) => {
                                            updateFilterAndClearData({
                                                key: TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER,
                                                value: {
                                                    ...filter,
                                                    completionDateFrom: startDate ? startDate.toISOString().slice(0, 10) : null,
                                                    completionDateTo: endDate ? endDate.toISOString().slice(0, 10) : null
                                                }
                                            })
                                        }}
                                        startDate={filter.completionDateFrom ? new Date(filter.completionDateFrom) : undefined}
                                        endDate={filter.completionDateTo ? new Date(filter.completionDateTo) : undefined}/>
                                }, {
                                    filterName: 'Отображаемые документы',
                                    filter: <div className='ml-2'><RadioGroup initialValue={filter.isDeleted?.toString() || 'false'} options={[{
                                        label: 'Активные',
                                        value: 'false'
                                    }, {
                                        label: 'Из корзины',
                                        value: 'true'
                                    }]} onChange={(event) => {
                                        updateFilterAndClearData({
                                            key: TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER,
                                            value: {
                                                ...filter,
                                                isDeleted: event.target.value === 'true',
                                            }
                                        });
                                    }}/></div>
                                },
                            ]
                        })))
    }, [filter]);

    useEffect(() => {
        if (tablePage) {
            if (!data || data.rows.length < (tablePage.pageNumber * DEFAULT_PRODUCTION_ORDER_ARCHIVE_FILTER.pageSize) + 1) {
                addData({key: TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER, data: tablePage})
            }
        }

    }, [tablePage]);

    return (<>
        <div className={tablePageStyle}>
            <GuideTopBox tableFilterKey={TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER}
                         searchInfo={"Поиск по № Work и основной продукции."}/>
            {data && <ProductionOrderArchiveTable data={data}/>}
        </div>
    </>)
}